import { Component, OnInit, TemplateRef, ViewChild, AfterViewInit } from '@angular/core';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import { BsModalService } from 'ngx-bootstrap';
import { CampaignService } from '../../../../common/services/Campaign.service';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'lodash';

declare var $: any;
declare var Chartist: any;

@Component({
    templateUrl: "campaign.template.html",
    styleUrls: ['campaign.css'],
    providers: [BsModalService, CampaignService]
})



export class CampaignComponent implements OnInit {
    public mode : any = 'list';
    public choice_campaign_id : any;
    constructor() {
        
    }

    ngOnInit() {
    }

    openMode($event) {
        this.mode = $event.mode;
        if(this.mode == 'detail') {
            this.choice_campaign_id = $event.id
        }
    }
    
}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/pages/admin/icontact/campaign/campaign.component.ts